// extracted by mini-css-extract-plugin
module.exports = {"bar":"ScrollProgress-module--bar--2xFPU"};